export const MESSAGE_TYPES = [
    { value: "Email", label: "Email" },
    { value: "Internal", label: "Internal Notification" },
    { value: "Mobile", label: "Mobile Notification" },
];

export const LANGUAGES = [
    { value: "English", label: "English" },
    { value: "Hebrew", label: "עברית" },
    { value: "Arabic", label: "عربيه" },
];
